<ng-template #content let-c="close" id="modal">
  <div class="modal-header">
    <h4 class="modal-title">{{isEditing?'Edit License' : 'New License'}}</h4>

    <button type="button" class="btn-close" aria-label="Close" (click)="onDismiss()">
    </button>
  </div>

  <div class="modal-body">

    <div class="row mb-4">
      <div class="form-group col-md-4">

        <label class="form-label modal-form-text">Type</label>
        <span class="text-muted ms-1">*</span>

        <select class=" form-control form-control-sm"
                #selectType
                [(ngModel)]="editingElement.docType">
          <option value="" disabled>Please select one</option>
          <option *ngFor="let type  of licensesType"
                  [selected]="type == editingElement.docType">
            {{type}}
          </option>
        </select>

      </div>
      <div class="form-group col-md-4">
        <ccc-input-text class="license-input-field"
                        title="Order Number"
                        [(field)]="editingElement.orderRef"
                        [(errors)]="errors['orderRef']"
                        minLength="1"
                        maxLength="20"
                        [required]="true">
        </ccc-input-text>

      </div>
      <div class="form-group col-md-4">
        <ccc-input-text class="license-input-field"
                        title="License Key"
                        [(field)]="editingElement.licenseKey"
                        [(errors)]="errors['licenseKey']"
                        minLength="8"
                        maxLength="20"
                        [required]="false">
        </ccc-input-text>

      </div>
    </div>

    <div class="d-flex form-row mb-4">
      <div class="form-group col-md-4">
        <label class="form-label"> Start Date</label>
        <span class="text-muted ms-1">*</span>
        <div class="input-group">
          <input class="date"
                 [readonly]="true"
                 placeholder="Select Date"
                 name="startDate"
                 [(ngModel)]="startDate"
                 ngbDatepicker
                 #datestart="ngbDatepicker"
                 [maxDate]="endDate"
                 (click)="datestart.toggle()" />
          <button class="btn btn-sm btn-outline-secondary p-1"
                  (click)="datestart.toggle()"
                  type="button">
            <i class="fas fa-calendar" aria-hidden="true"></i>
          </button>
        </div>

      </div>
      <div class="form-group col-md-4">
        <label class="form-label"> End Date</label>
        <span class="text-muted ms-1">*</span>
        <div class="input-group">
          <input class="date"
                 [readonly]="true"
                 placeholder="Select Date"
                 name="endDate"
                 [(ngModel)]="endDate"
                 ngbDatepicker #dateend="ngbDatepicker"
                 [minDate]="getMinEndDate()"
                 (click)="dateend.toggle()" />
          <button class="btn btn-sm btn-outline-secondary p-1" (click)="dateend.toggle()" type="button">
            <i class="fas fa-calendar" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="form-group col-md-4">
      </div>
    </div>
    <div class="row mb-4">
      <div class="form-group col-md-4">
        <ccc-error-container [errors]="errors['remoteSystem']">
          <label class="form-label modal-form-text">Program License Code </label>
          <span class="text-muted ms-1">*</span>
          <select class="form-control form-control-sm  affiliation" [(ngModel)]="editingElement.externalProductId">
            <option value="" selected disabled>Please select </option>
            <option *ngFor="let ppc of programProdCodes" [value]="ppc">{{ppc}}</option>
          </select>
        </ccc-error-container>
      </div>
      <div class="form-group col-md-4">

        <ccc-validated-input-field title="Quantity" [field]="editingElement.purchasedSeats" inputType="number"
          [errors]="errors['purchasedSeats']" (changesMade)="editingElement.purchasedSeats = $event" [required]="true">
        </ccc-validated-input-field>
      </div>
      <div class="form-group col-md-4">
        <ccc-validated-input-field title="Notes" [field]="editingElement.notes" [errors]="errors['notes']"
          checkLength="false" maxLenght="50" (changesMade)="editingElement.notes = $event">
        </ccc-validated-input-field>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-cancel" (click)="onDismiss()">Cancel</button>
    <div *ngIf="isSending">
      <i class="fas fa-spinner fa-spin fa-lg icons loading-icon me-2"> </i>
    </div>
    <button type="submit"
            [disabled]=" isSending || !hasUnsavedChanges() || !canAdd()"
            class="btn-save btn-primary"
            (click)="onSubmit()">Save</button>

  </div>
</ng-template>

<ccc-confirm-modal #modalSave (confirmAction)="onCloseWithoutSaving($event)"></ccc-confirm-modal>
